/**
 * Ottiene il messaggio di un errore avvenuto a livello di network.
 */
export function getNetworkErrorMessage(err: any, defaultMessage?: string) {
  if (err.response && err.response.data && err.response.data.message) {
    return err.response.data.message;
  }

  if (err.message) return err.message;

  return defaultMessage || err;
}
